export enum SortDirection {
  ascending = "ASC",
  descending = "DESC",
}
